import { LOADING_FIGURES, RECEIVED_FIGURES, RECEIVED_FIGURES_FAILED } from '../types';
import { createFetcher } from '../utils';
import { identificationType } from '../../constants';

export default {
  urlFormatter: {
    [identificationType.pii]: ({ pii, token }) => `/enhancements/article/pii/${pii}/figures?token=${token}`,
  },
  fetch: createFetcher(
    LOADING_FIGURES, RECEIVED_FIGURES, RECEIVED_FIGURES_FAILED,
  ),
};
